"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = void 0;
var tslib_1 = require("tslib");
function delay(ms) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, ms); })];
        });
    });
}
exports.delay = delay;
//# sourceMappingURL=delay.js.map